// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.common-error-container{min-height:20rem;height:100%}
`, "",{"version":3,"sources":["webpack://./src/components/shared/StatusWrappers/ErrorStatus.scss"],"names":[],"mappings":"AAAA,wBACE,gBAAiB,CACjB,WAAY","sourcesContent":[".common-error-container {\n  min-height: 20rem;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
